(function () {
  if (!window.CfonElements) return;

  const WRITE_EVENT = 'cfon:reviews:write';
  const SORT_EVENT = 'cfon:reviews:sort';
  const SORTED_EVENT = 'cfon:reviews:sorted';
  const WRITE_BUTTON = '[data-testid="write-review-button"]';
  const SORT_SELECT = '.jm-sort-filter__select';
  const RETRY_MS = 200;
  const MAX_TRIES = 75;

  // Bridges CFON blocks to the Judge.me review widget (new version) nested inside this block.
  // Judge.me renders the widget asynchronously, so each action retries until its control exists.
  class CfonJudgemeReviews extends CfonElements.Component {
    onConnect() {
      this.widget = this.querySelector('.jdgm-review-widget');
      this.toggleAttribute('data-form-unavailable', !this.widget);
      this.timers = new Set();

      this.onWrite = (event) => {
        event.stopPropagation();
        this.whenReady(WRITE_BUTTON, (button) => button.click());
      };
      this.onSort = (event) => {
        event.stopPropagation();
        const sort = event.detail && event.detail.sort;
        this.whenReady(SORT_SELECT, (select) => {
          if (select.value === sort || ![...select.options].some((option) => option.value === sort)) return;
          select.value = sort;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      };
      // Judge.me's own select (ours or its widget) reports the active sort to the filter buttons.
      this.onChange = (event) => {
        if (event.target.matches && event.target.matches(SORT_SELECT)) this.announceSort(event.target.value);
      };

      this.addEventListener(WRITE_EVENT, this.onWrite);
      this.addEventListener(SORT_EVENT, this.onSort);
      this.addEventListener('change', this.onChange);
      this.whenReady(SORT_SELECT, (select) => this.announceSort(select.value));
    }

    onDisconnect() {
      this.removeEventListener(WRITE_EVENT, this.onWrite);
      this.removeEventListener(SORT_EVENT, this.onSort);
      this.removeEventListener('change', this.onChange);
      this.timers.forEach(clearTimeout);
      this.timers.clear();
      this.widget = null;
    }

    whenReady(selector, callback, tries = 0) {
      const element = this.widget && this.widget.querySelector(selector);
      if (element) {
        callback(element);
        return;
      }
      if (!this.widget || tries >= MAX_TRIES) return;
      const timer = setTimeout(() => {
        this.timers.delete(timer);
        this.whenReady(selector, callback, tries + 1);
      }, RETRY_MS);
      this.timers.add(timer);
    }

    announceSort(sort) {
      this.dispatchEvent(new CustomEvent(SORTED_EVENT, { detail: { sort } }));
    }
  }

  // "Write a review" call to action (and its decorative box); delivers the request to the parent block.
  class CfonReviewWrite extends CfonElements.Component {
    onConnect() {
      this.onClick = (event) => {
        const control = event.target.closest('[data-review-write]');
        if (!control || !this.contains(control)) return;
        event.preventDefault();
        this.dispatchEvent(new CustomEvent(WRITE_EVENT, { bubbles: true }));
      };
      this.addEventListener('click', this.onClick);
    }

    onDisconnect() {
      this.removeEventListener('click', this.onClick);
    }
  }

  // Filter buttons; request a Judge.me sort and mirror the active one with aria-pressed.
  class CfonReviewFilters extends CfonElements.Component {
    onConnect() {
      this.hub = this.closest('cfon-judgeme-reviews');
      this.onClick = (event) => {
        const button = event.target.closest('[data-review-sort]');
        if (!button || !this.contains(button)) return;
        this.setActive(button.dataset.reviewSort);
        this.dispatchEvent(new CustomEvent(SORT_EVENT, { bubbles: true, detail: { sort: button.dataset.reviewSort } }));
      };
      this.onSorted = (event) => this.setActive(event.detail && event.detail.sort);
      this.addEventListener('click', this.onClick);
      if (this.hub) this.hub.addEventListener(SORTED_EVENT, this.onSorted);
    }

    onDisconnect() {
      this.removeEventListener('click', this.onClick);
      if (this.hub) this.hub.removeEventListener(SORTED_EVENT, this.onSorted);
      this.hub = null;
    }

    setActive(sort) {
      this.querySelectorAll('[data-review-sort]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.reviewSort === sort));
      });
    }
  }

  CfonElements.define('cfon-judgeme-reviews', CfonJudgemeReviews);
  CfonElements.define('cfon-review-write', CfonReviewWrite);
  CfonElements.define('cfon-review-filters', CfonReviewFilters);
})();
